/* eslint-disable react/no-danger */
import React from 'react'

import Modal from 'react-modal'

import { func, string } from 'prop-types'

import ModalHeader from './Components/ModalHeader/ModalHeader'

const GeneralTermsAndConditionsLink = (
  <a href='/pages/terms-and-conditions#general-terms-of-licensing' target='_blank'>
    General Terms and Condition
  </a>
)

function LicenseModal({
  closeModal,
  id,
  customLicense = '',
  licenseTitle,
}) {
  const renderContent = () => {
    switch (id) {
      case 'royalty_free':
        return (
          <>
            <p>
              Royalty Free License allows you to use the product without the need to pay earnings or other{' '}
              license fees for multiple uses, per volume sold, or some time period of use or sales.{' '}
              You can use it as long as it is incorporated into the product and the 3rd party cannot retrieve it{' '}
              individually in either the digital or physical form.{' '}
              You cannot resell the model you bought in the digital or printed form, but can use it in your{' '}
              commercial projects multiple times after paying for it just once.
            </p>
            <p>
              This is, however, a non-exclusive license and the product remains the property of a seller for{' '}
              further distribution. Please, refer to legally binding{' '}
              {GeneralTermsAndConditionsLink}
              {' '}to learn more about{' '}
              <a href='/pages/terms-and-conditions#royalty-free-license' target='_blank'>
                Royalty Free License
              </a>
              , other types of licenses and general rules applicable to all products.
            </p>
          </>
        )
      case 'royalty_free_no_ai':
        return (
          <>
            <p>
              Royalty Free License allows you to use the product without the need to pay earnings or other{' '}
              license fees for multiple uses, per volume sold, or some time period of use or sales.{' '}
              You can use it as long as it is incorporated into the product and the 3rd party cannot retrieve it{' '}
              individually in either the digital or physical form.{' '}
              You cannot resell the model you bought in the digital or printed form, but can use it in your{' '}
              commercial projects multiple times after paying for it just once.{' '}
              Licenses marked with "no AI" tag do not permit Product use for machine learning or training of{' '}
              neural network models, including generative AI models.
            </p>
            <p>
              This is, however, a non-exclusive license and the product remains the property of a seller for{' '}
              further distribution. Please, refer to legally binding{' '}
              {GeneralTermsAndConditionsLink}
              {' '}to learn more about{' '}
              <a href='/pages/terms-and-conditions#royalty-free-license' target='_blank'>
                Royalty Free License No AI
              </a>
              , other types of licenses and general rules applicable to all products.
            </p>
          </>
        )
      case 'custom':
        return (
          <>
            <p>
              Custom License allows uses of the product as specified by designer. Such additional license{' '}
              terms shall be applied and interpreted as additions and (or) exceptions to the conditions set by{' '}
              general licensing terms and Royalty Free License. The product published with the Custom License{' '}
              label shall be deemed applicable if and only if the Seller provides additional license terms on{' '}
              the content.
            </p>
            <p>
              Additional conditions specified by the seller of this model:
            </p>
            <strong dangerouslySetInnerHTML={{__html: customLicense}} />
            <p>
              Refer to legally binding{' '}
              {GeneralTermsAndConditionsLink}
              {' '}to learn more about conditions regarding extracting product from end product created, which{' '}
              applies to all models under any license.
            </p>
          </>
        )
      case 'custom_no_ai':
        return (
          <>
            <p>
              Custom License allows uses of the product as specified by designer. Such additional license{' '}
              terms shall be applied and interpreted as additions and (or) exceptions to the conditions set by{' '}
              general licensing terms and Royalty Free License. The product published with the Custom License{' '}
              label shall be deemed applicable if and only if the Seller provides additional license terms on{' '}
              the content.{' '}
              Licenses marked with "no AI" tag do not permit Product use for machine learning or training of{' '}
              neural network models, including generative AI models.
            </p>
            <p>
              Additional conditions specified by the seller of this model:
            </p>
            <strong dangerouslySetInnerHTML={{__html: customLicense}} />
            <p>
              Refer to legally binding{' '}
              {GeneralTermsAndConditionsLink}
              {' '}to learn more about conditions regarding extracting product from end product created, which{' '}
              applies to all models under any license.
            </p>
          </>
        )
      case 'editorial_no_ai':
        return (
          <>
            <p>
              Editorial license gives a permission to use the product only in an editorial manner, relating to{' '}
              events that are newsworthy, or of public interest, and may not be used for any commercial,{' '}
              promotional, advertising or merchandising use.{' '}
              Licenses marked with "no AI" tag do not permit Product use for machine learning or training of{' '}
              neural network models, including generative AI models.
            </p>
            <p>
              In a few instances, you may otherwise have the rights to IP in content that is under Editorial{' '}
              license. For instance, you may be the advertising agency for a brand/IP owner or you may be the{' '}
              brand/IP owner itself purchasing user generated content. Given you have the rights clearance{' '}
              through other means, you may use the content under Editorial License commercially. Every user{' '}
              failing to comply with Editorial Use restrictions takes the responsibility to prove the{' '}
              ownership of IP rights.
            </p>
            <span>
              For users, who are not brand/IP owners or official affiliates, the restrictions of{' '}
              Editorial-licensed content usage include, but are not limited to, the following cases:
            </span>
            <ul>
              <li>
                Products may not be used on any item/product created for resale such as, commercials,{' '}
                for-profit animations, video games, VR/AR applications, or physical products such as a{' '}
                merchandise or t-shirt.
              </li>
              <li>
                Products may not be used as part of own product promotional materials, billboard, trade show{' '}
                or exhibit display.
              </li>
              <li>
                The product may not be incorporated into a logo, trademark or service mark. As an example,{' '}
                you cannot use Editorial content to create a logo design.
              </li>
              <li>
                Products may not be used in any insulting, abusive or otherwise unlawful manner.
              </li>
              <li>
                The product may not be used for any commercial related purpose.
              </li>
            </ul>
            <p>
              Read more about{' '}
              <a href='/pages/terms-and-conditions#editorial-license' target='_blank'>
                Editorial License
              </a>
              {' '}and product usage allowed by different licenses in our legally binding{' '}
              {GeneralTermsAndConditionsLink}
            </p>
          </>
        )
      default:
        return null
    }
  }

  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="License details"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--license',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="license-modal">
        <ModalHeader closeModal={closeModal} title={licenseTitle} />
        <div className="license-modal__content">
          {renderContent()}
        </div>
      </div>
    </Modal>
  )
}

LicenseModal.propTypes = {
  closeModal: func.isRequired,
  id: string.isRequired,
  customLicense: string,
  licenseTitle: string.isRequired,
}

export default LicenseModal
